import { createContext, useContext } from 'react';

export const ContentEditorContext = createContext(null);
export function useContentEditorContext() { return useContext(ContentEditorContext); }
